import { createAsyncThunk } from '@reduxjs/toolkit'
import { getAuth } from 'firebase/auth'
import { app } from 'app/providers/FirebaseProvider/ui/FirebaseProvider'
import { BACKEND_DATA_SOURCE, selectDataSource } from 'shared/api/dataSource'
import { fetchPendingAdminSuggestions } from 'shared/api/admin'
import { loadLegacyFirestore } from 'shared/firebase/loadLegacyFirebase'

export const fetchSuggestData = createAsyncThunk(
    'card/fetchSuggestData',
    async () => {
        if (
            selectDataSource(getAuth(app).currentUser?.uid) ===
            BACKEND_DATA_SOURCE
        ) {
            const result = await fetchPendingAdminSuggestions()
            return result.suggestions
        }
        const { collection, db, getDocs } = await loadLegacyFirestore()
        const suggestData = await getDocs(collection(db, 'suggests')).then(
            (querySnapshot) => {
                const newData = querySnapshot.docs.map((doc) => ({
                    ...doc.data(),
                }))
                const data = newData.sort((a, b) => a.id - b.id)
                return data
            }
        )
        return suggestData
    }
)
